import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import get from 'lodash/get';
import { ReactElement, useState } from 'react'; // useEffect removido!
import { backgroundColorDarkTheme } from '../../styles/global.styles';

interface DropdownV2Props {
  label: string;
  value: any;
  disabled?: boolean;
  optionLabel: string;
  optionValue: string;
  optionIcon?: string;
  errorMessage?: string;
  options: any[];
  additionalButton?: ReactElement;
  onChange: (val: any) => void;
}

const DropdownV2 = ({
  label,
  value,
  onChange,
  optionLabel,
  optionValue,
  optionIcon,
  disabled,
  errorMessage,
  options,
  additionalButton,
}: DropdownV2Props) => {
  const [open, setOpen] = useState(false);
  const safeValue = value ?? '';

  return (
    <Box sx={{ display: 'flex', marginBottom: '24px' }}>
      <FormControl fullWidth>
        <InputLabel
          id={`select-label-${label}`}
          sx={{ color: disabled ? 'rgb(96,96,96)' : '#fff' }}
        >
          {label}
        </InputLabel>
        <Select
          labelId={`select-label-${label}`}
          id={`select-${label}`}
          value={safeValue}
          label={label}
          disabled={disabled}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          onChange={({ target: { value } }) => {
            onChange(value);
          }}
          sx={{
            '&.Mui-disabled': {
              backgroundColor: 'rgba(0, 0, 0, 0.12)',
            },
          }}
          IconComponent={() =>
            open ? (
              <ArrowDropUp sx={{ color: '#ffffff' }} />
            ) : (
              <ArrowDropDown sx={{ color: '#ffffff' }} />
            )
          }
        >
          {options?.map((option) => (
            <MenuItem
              sx={{
                backgroundColor: backgroundColorDarkTheme,
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
              value={get(option, optionValue)}
              key={get(option, optionValue)}
            >
              <Box
                sx={{
                  flexDirection: 'row',
                  display: 'flex',
                  my: 0,
                  py: 0,
                  alignItems: 'center',
                }}
              >
                {optionIcon && (
                  <Typography
                    sx={{ mr: 0.5, display: 'flex', alignItems: 'center' }}
                  >
                    {get(option, optionIcon)}
                  </Typography>
                )}
                <Typography>{get(option, optionLabel)}</Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
        {errorMessage && (
          <Typography fontSize={12} color={'#ff0000'} mt={0.5}>
            {errorMessage}
          </Typography>
        )}
      </FormControl>
      {additionalButton}
    </Box>
  );
};

export default DropdownV2;